import React from 'react';
import DataTable from '@/components/ui/DataTable';
import Pagination from '@/components/ui/Pagination';

export const LeadExecutionTableView = ({
  columns,
  executions,
  isLoading,
  onRowClick,
  page,
  setPage,
  totalPages,
  totalItems
}) => {
  return (
    <>
      <div className="min-w-0">
        <DataTable
          columns={columns}
          data={executions}
          isLoading={isLoading}
          onRowClick={onRowClick}
        />
      </div>

      <div className="border-t border-slate-50 bg-white">
        <Pagination
          page={page}
          totalPages={totalPages}
          totalItems={totalItems}
          onPageChange={setPage}
        />
      </div>
    </>
  );
};
